import React, { FC, RefObject, useMemo } from 'react';
import classNames from 'classnames';
import nextId from 'react-id-generator';
import {
    OrderPartsImg,
    ProductThumbnail,
    OnSelectProductHandler,
} from '@root/app/react/uikit';
import { useLayoutContext } from '@component/OrderProductCategoryList';
import { IinitState } from '@root/app/react/reducer/PartsSelectReducer';
import { useMediaDesktop } from '@app/react/common/useMedia';
import { PartsProduct } from '../const/type';
import { OrderSelectBaseLayout } from './OrderSelectBaseLayout';

interface IOrderCommon2SelectComponentProps {
    rootRef: RefObject;
    classes: string;
    partsNameProps: string;
    customizeData: IinitState;
    onSelectProduct: OnSelectProductHandler;
    partsData: PartsProduct[];
    className?: string;
    LameHtml?: React.ReactNode;
    kind:
    | 'lame'
    | 'arrowinsert'
    | 'nock'
    | 'arrowhead'
    | 'kebiki'
    | 'unit'
    | 'decoration';
    showHelpBtn: boolean;
    onHelpClick: (
        event: React.MouseEvent<HTMLButtonElement, MouseEvent>
    ) => void;
}

export const OrderCommon2SelectComponent: FC<IOrderCommon2SelectComponentProps> = (
    props,
) => {
    const {
        rootRef,
        classes,
        partsNameProps,
        customizeData,
        onSelectProduct,
        partsData,
        className,
        LameHtml = null,
        kind,
        showHelpBtn,
        onHelpClick,
    } = props;

    const rootClassName = classNames(classes, {
        [className]: className !== undefined,
    });

    const htmlId = useMemo(() => nextId(classes), [classes]);
    const isDesktop = useMediaDesktop();

    const lc = useLayoutContext();
    const enableTwoCol = lc.testTwoCol('', '');
    const className2 = enableTwoCol ? 'type-c' : (lc.productThumbnailType ?? undefined);

    return (
        <OrderSelectBaseLayout
            classNames={{ root: rootClassName }}
            header={isDesktop && (
                <OrderPartsImg
                    partsName={partsNameProps}
                    showHelpBtn={showHelpBtn}
                    onHelpClick={onHelpClick}
                />
            )}
            body={(
                <>
                    <div className="design-container">
                        <div className="container-overflow" ref={rootRef}>
                            {LameHtml}
                            <ul className={classNames('product-container', { 'two-col': enableTwoCol })}>
                                {partsData.map((product) => {
                                    const checked = customizeData[kind]?.id === product.id;
                                    return (
                                        <ProductThumbnail
                                            key={product.id}
                                            className={className2}
                                            product={product}
                                            onClick={onSelectProduct}
                                            checked={checked}
                                            groupName={htmlId}
                                        />
                                    );
                                })}
                            </ul>
                        </div>
                    </div>
                </>
            )}
        />
    );
};
